"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_TYPE_TOKEN_ONETIME_SEED = exports.AUTH_TYPE_TOKEN_ONETIME = exports.AUTH_ANONYMOUS = exports.AUTH_TYPE_TOKEN = void 0;
exports.AUTH_TYPE_TOKEN = 'token';
exports.AUTH_ANONYMOUS = 'anonymous';
exports.AUTH_TYPE_TOKEN_ONETIME = 'token.onetime';
exports.AUTH_TYPE_TOKEN_ONETIME_SEED = 'token.onetime.seed';
